// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportGreenBtnWrapper {
  display: flex;
  margin: 20px 0px;
  gap: 14px;
  overflow-x: auto;
  padding: 10px 0px;
}

.timeline {
  position: relative;
  padding-left: 30px;
  margin: 20px 0;
}

.timeline > :nth-child(1) {
  position: absolute;
  top: 10px;
  bottom: 63px;
  width: 1px;
  background-color: rgba(115, 119, 145, 0.5);
  left: 36px;
}

.timelineItem {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  position: relative;
}

.timelineDot {
  position: relative;
  left: -2px;
  top: 5px;
  width: 17px;
  height: 17px;
  border-radius: 30px;
  background-color: #fff;
  border: 1px solid gray;
}
.timelineDot > div {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: var(--lightBlue);
  border-radius: 20px;
  position: absolute;
  left: 12%;
  top: 12%;
}

.timelineContent {
  margin-left: 20px;
}

h4 {
  font-size: 16px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.roleBadge {
  font-size: 14px !important;
  color: #fff;
  padding: 3px 8px;
  border-radius: 15px;
  background-color: #007bff;
  text-wrap: nowrap;
  line-height: 2;
}

.date {
  color: var(--lightBlue);
  font-size: 14px;
}

.statusBadge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-block;
  text-transform: capitalize;
}

.statusBadge.new {
  background-color: #e3f2fd;
  color: #1976d2;
}

.statusBadge.pending_hod {
  background-color: #ede7f6;
  color: #5e35b1;
}

.statusBadge.pending_supervisor {
  background-color: #cfd8dc;
  color: #263238;
}

.statusBadge.approved {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.statusBadge.pending {
  background-color: #fff3e0;
  color: #ef6c00;
}

.reason {
  font-size: 14px;
  color: gray;
  margin-top: 5px;
  text-transform: capitalize;
}

.deleteBtn {
  border: none;
  background-color: transparent;
}

.deleteBtn:disabled {
  opacity: 50%;
}

.full-width-modal {
  max-width: 94vw !important;
  width: 94vw !important;
}

.previewWrapper {
  height: 68vh;
  overflow-y: auto;
  position: relative;
}

.bold-text {
  font-weight: 800 !important;
  text-wrap: nowrap;
}

.bottomStatusWithNameWrapper {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  text-wrap: nowrap;
}

.bottomStatusWithNameWrapper > :nth-child(1) {
  font-weight: 700;
  color: var(--green);
  text-wrap: nowrap;
}
.bottomStatusWithNameWrapper > :nth-child(2) {
  font-weight: 700;
  text-transform: capitalize;
  text-wrap: nowrap;
}

.reportPreviewWrapper {
  width: 100%;
}

.reportPreviewWrapper table {
  width: 100%;
  border-collapse: collapse;
  font-size: 8px;
  /* border: 1px solid gray; */
}

.reportPreviewWrapper th,
.reportPreviewWrapper td {
  border: 1px solid gray;
  text-align: center;
  max-height: 20px;
  padding: 2px;
}

.reportPreviewWrapper p {
  margin: auto;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: center;
  text-transform: capitalize;
}

.balanceWrapper {
  position: absolute;
  right: 10px;
  top: -10px;
  font-size: 8px;
  font-weight: 700;
  text-wrap: nowrap;
}

.topRightInfoWrapper {
  font-size: 8px;
  font-weight: 700;
  text-wrap: nowrap;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2px 6px;
}

.editIconBtn {
  border: none;
  background-color: transparent;
  border-radius: 50px;
  color: var(--green);
  padding: 0px;
  width: 26px;
  height: 26px;
  font-size: 12px;
  margin-right: 16px;
  font-weight: 900;
}

.cancelIconBtn {
  border: none;
  background-color: transparent;
  border-radius: 50px;
  padding: 0px;
  width: 26px;
  height: 26px;
  font-size: 10px;
  margin-right: 7px;
  border: 2px solid red;
}

.infoWithLabelWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  /* font-size: 1px; */
}
.infoWithLabelWrapper label {
  font-weight: 700;
}

.calculationWrapper {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: end;
  margin-top: 20px;
  flex-wrap: wrap;
}

.calculationWrapper h6 {
  padding: 3px 10px 2px 10px;
  border-radius: 20px;
  font-weight: 600;
}
.calculationWrapper > :nth-child(1) {
  background-color: #c8e2fe;
}
.calculationWrapper > :nth-child(2) {
  background-color: #c8e2fe;
}
.calculationWrapper > :nth-child(3) {
  background-color: #bbf8e1;
}
.calculationWrapper > :nth-child(4) {
  background-color: #bbf8e1;
}
.attendanceSelect {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border-color: #3a57e8;
  padding: 0px 10px;
}
.attendanceSelect:disabled {
  background-color: rgb(240, 240, 240);
}

.attendancePresentAbsentWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.attendancePresentAbsentWrapper > :nth-child(2) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.attendancePresentAbsentWrapper > :nth-child(2) > :nth-child(1) {
  padding: 3px 16px 2px 16px;
  border-radius: 10px;
  height: 50px;
  font-weight: 600;
  background-color: #aef3d8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.attendancePresentAbsentWrapper > :nth-child(2) > :nth-child(2) {
  padding: 3px 16px 2px 16px;
  border-radius: 10px;
  height: 50px;
  font-weight: 600;
  background-color: #f9c8c8;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ------------- Media Query------------------- */
@media (max-width: 1000px) {
  .calculationWrapper h6 {
    font-size: 14px;
  }
  .infoWithLabelWrapper label {
    font-size: 14px;
  }
  .infoWithLabelWrapper p {
    font-size: 14px;
  }
  .attendancePresentAbsentWrapper > :nth-child(2) > h6 {
    height: 35px !important;
    /* font-size: 14px; */
  }
}
@media (max-width: 750px) {
  .calculationWrapper h6 {
    font-size: 12px;
  }
  .infoWithLabelWrapper label {
    font-size: 14px;
  }
  .infoWithLabelWrapper p {
    font-size: 14px;
  }
  .attendancePresentAbsentWrapper > :nth-child(2) > h6 {
    height: 26px !important;
    font-size: 12px;
    padding: 0px 10px !important;
    border-radius: 6px !important;
  }
  .reportStatusWrapper {
    font-size: 12px !important;
    margin-top: 20px;
  }
  .calculationWrapper {
    justify-content: center;
  }
  .roleBadge {
    font-size: 12px !important;
    padding: 1px 8px;
  }
  .timelineContent h6 {
    font-size: 12px;
  }
  .timelineContent p {
    font-size: 12px;
  }
  .timelineDot {
    border: none;
  }
}

/* Export Dropdown Styling */
.dropdown-toggle::after {
  display: none !important;
}

.dropdown-menu {
  border: none !important;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 8px !important;
  border-radius: 12px !important;
}

.dropdown-item {
  padding: 10px 16px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  color: #4a5568 !important;
  transition: all 0.2s ease !important;
}

.dropdown-item:hover {
  background-color: #f7fafc !important;
  color: #3a57e8 !important;
  transform: translateX(4px);
}

/* Report Preview responsive styles (report?reportId) */
.reportSectionCard {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  background-color: #e9f0fb;
  margin-bottom: 16px;
}

.reportSectionTitle {
  font-size: 20px;
  font-weight: 700;
  color: #2f3299;
  border-bottom: 2px solid #000;
  padding-bottom: 6px;
  display: inline-block;
  margin-bottom: 16px;
}

.reportInlineRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 32px;
  margin-bottom: 10px;
  align-items: center;
}

.reportField {
  color: #2d3748;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.reportLabel {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.reportValue {
  font-size: 15px;
  font-weight: 400;
  color: #2d3748;
}

@media (max-width: 768px) {
  .reportSectionCard {
    padding: 16px;
    border-radius: 8px;
  }

  .reportSectionTitle {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .reportInlineRow {
    gap: 8px 16px;
  }

  .reportField {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .reportLabel {
    font-size: 14px;
  }

  .reportValue {
    font-size: 13.5px;
  }
}

/* Spreadsheet Layout for ReportComponent */
.spreadsheet-container {
  width: 100%;
  overflow-x: auto;
  background-color: #ffffff;
  padding: 20px;
}

.spreadsheet-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  border: 1px solid #d1d5db;
}

.spreadsheet-table th,
.spreadsheet-table td {
  border: 1px solid #d1d5db;
  padding: 12px 16px;
  text-align: center;
  white-space: nowrap;
  font-size: 13px;
}

.spreadsheet-table th {
  background-color: #f9fafb;
  color: #374151;
  font-weight: 600;
  text-transform: capitalize;
}

.spreadsheet-table tr:nth-child(2) th {
  font-size: 11px;
  color: #6b7280;
  background-color: #ffffff;
  padding: 4px 16px;
}

.spreadsheet-table tbody tr:hover {
  background-color: #f3f4f6;
}

.spreadsheet-td-val {
  color: #111827;
  font-weight: 500;
}

`, "",{"version":3,"sources":["webpack://./src/components/report/report.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".reportGreenBtnWrapper {\n  display: flex;\n  margin: 20px 0px;\n  gap: 14px;\n  overflow-x: auto;\n  padding: 10px 0px;\n}\n\n.timeline {\n  position: relative;\n  padding-left: 30px;\n  margin: 20px 0;\n}\n\n.timeline > :nth-child(1) {\n  position: absolute;\n  top: 10px;\n  bottom: 63px;\n  width: 1px;\n  background-color: rgba(115, 119, 145, 0.5);\n  left: 36px;\n}\n\n.timelineItem {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.timelineDot {\n  position: relative;\n  left: -2px;\n  top: 5px;\n  width: 17px;\n  height: 17px;\n  border-radius: 30px;\n  background-color: #fff;\n  border: 1px solid gray;\n}\n.timelineDot > div {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background-color: var(--lightBlue);\n  border-radius: 20px;\n  position: absolute;\n  left: 12%;\n  top: 12%;\n}\n\n.timelineContent {\n  margin-left: 20px;\n}\n\nh4 {\n  font-size: 16px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.roleBadge {\n  font-size: 14px !important;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 15px;\n  background-color: #007bff;\n  text-wrap: nowrap;\n  line-height: 2;\n}\n\n.date {\n  color: var(--lightBlue);\n  font-size: 14px;\n}\n\n.statusBadge {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n  display: inline-block;\n  text-transform: capitalize;\n}\n\n.statusBadge.new {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.statusBadge.pending_hod {\n  background-color: #ede7f6;\n  color: #5e35b1;\n}\n\n.statusBadge.pending_supervisor {\n  background-color: #cfd8dc;\n  color: #263238;\n}\n\n.statusBadge.approved {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.statusBadge.pending {\n  background-color: #fff3e0;\n  color: #ef6c00;\n}\n\n.reason {\n  font-size: 14px;\n  color: gray;\n  margin-top: 5px;\n  text-transform: capitalize;\n}\n\n.deleteBtn {\n  border: none;\n  background-color: transparent;\n}\n\n.deleteBtn:disabled {\n  opacity: 50%;\n}\n\n.full-width-modal {\n  max-width: 94vw !important;\n  width: 94vw !important;\n}\n\n.previewWrapper {\n  height: 68vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.bold-text {\n  font-weight: 800 !important;\n  text-wrap: nowrap;\n}\n\n.bottomStatusWithNameWrapper {\n  display: flex;\n  text-align: center;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n  text-wrap: nowrap;\n}\n\n.bottomStatusWithNameWrapper > :nth-child(1) {\n  font-weight: 700;\n  color: var(--green);\n  text-wrap: nowrap;\n}\n.bottomStatusWithNameWrapper > :nth-child(2) {\n  font-weight: 700;\n  text-transform: capitalize;\n  text-wrap: nowrap;\n}\n\n.reportPreviewWrapper {\n  width: 100%;\n}\n\n.reportPreviewWrapper table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 8px;\n  /* border: 1px solid gray; */\n}\n\n.reportPreviewWrapper th,\n.reportPreviewWrapper td {\n  border: 1px solid gray;\n  text-align: center;\n  max-height: 20px;\n  padding: 2px;\n}\n\n.reportPreviewWrapper p {\n  margin: auto;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  text-align: center;\n  text-transform: capitalize;\n}\n\n.balanceWrapper {\n  position: absolute;\n  right: 10px;\n  top: -10px;\n  font-size: 8px;\n  font-weight: 700;\n  text-wrap: nowrap;\n}\n\n.topRightInfoWrapper {\n  font-size: 8px;\n  font-weight: 700;\n  text-wrap: nowrap;\n  flex-wrap: wrap;\n  gap: 4px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 2px 6px;\n}\n\n.editIconBtn {\n  border: none;\n  background-color: transparent;\n  border-radius: 50px;\n  color: var(--green);\n  padding: 0px;\n  width: 26px;\n  height: 26px;\n  font-size: 12px;\n  margin-right: 16px;\n  font-weight: 900;\n}\n\n.cancelIconBtn {\n  border: none;\n  background-color: transparent;\n  border-radius: 50px;\n  padding: 0px;\n  width: 26px;\n  height: 26px;\n  font-size: 10px;\n  margin-right: 7px;\n  border: 2px solid red;\n}\n\n.infoWithLabelWrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* font-size: 1px; */\n}\n.infoWithLabelWrapper label {\n  font-weight: 700;\n}\n\n.calculationWrapper {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  justify-content: end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n}\n\n.calculationWrapper h6 {\n  padding: 3px 10px 2px 10px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n.calculationWrapper > :nth-child(1) {\n  background-color: #c8e2fe;\n}\n.calculationWrapper > :nth-child(2) {\n  background-color: #c8e2fe;\n}\n.calculationWrapper > :nth-child(3) {\n  background-color: #bbf8e1;\n}\n.calculationWrapper > :nth-child(4) {\n  background-color: #bbf8e1;\n}\n.attendanceSelect {\n  width: 100%;\n  height: 50px;\n  border-radius: 5px;\n  border-color: #3a57e8;\n  padding: 0px 10px;\n}\n.attendanceSelect:disabled {\n  background-color: rgb(240, 240, 240);\n}\n\n.attendancePresentAbsentWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.attendancePresentAbsentWrapper > :nth-child(2) {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.attendancePresentAbsentWrapper > :nth-child(2) > :nth-child(1) {\n  padding: 3px 16px 2px 16px;\n  border-radius: 10px;\n  height: 50px;\n  font-weight: 600;\n  background-color: #aef3d8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.attendancePresentAbsentWrapper > :nth-child(2) > :nth-child(2) {\n  padding: 3px 16px 2px 16px;\n  border-radius: 10px;\n  height: 50px;\n  font-weight: 600;\n  background-color: #f9c8c8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ------------- Media Query------------------- */\n@media (max-width: 1000px) {\n  .calculationWrapper h6 {\n    font-size: 14px;\n  }\n  .infoWithLabelWrapper label {\n    font-size: 14px;\n  }\n  .infoWithLabelWrapper p {\n    font-size: 14px;\n  }\n  .attendancePresentAbsentWrapper > :nth-child(2) > h6 {\n    height: 35px !important;\n    /* font-size: 14px; */\n  }\n}\n@media (max-width: 750px) {\n  .calculationWrapper h6 {\n    font-size: 12px;\n  }\n  .infoWithLabelWrapper label {\n    font-size: 14px;\n  }\n  .infoWithLabelWrapper p {\n    font-size: 14px;\n  }\n  .attendancePresentAbsentWrapper > :nth-child(2) > h6 {\n    height: 26px !important;\n    font-size: 12px;\n    padding: 0px 10px !important;\n    border-radius: 6px !important;\n  }\n  .reportStatusWrapper {\n    font-size: 12px !important;\n    margin-top: 20px;\n  }\n  .calculationWrapper {\n    justify-content: center;\n  }\n  .roleBadge {\n    font-size: 12px !important;\n    padding: 1px 8px;\n  }\n  .timelineContent h6 {\n    font-size: 12px;\n  }\n  .timelineContent p {\n    font-size: 12px;\n  }\n  .timelineDot {\n    border: none;\n  }\n}\n\n/* Export Dropdown Styling */\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.dropdown-menu {\n  border: none !important;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1) !important;\n  padding: 8px !important;\n  border-radius: 12px !important;\n}\n\n.dropdown-item {\n  padding: 10px 16px !important;\n  border-radius: 8px !important;\n  font-weight: 500 !important;\n  color: #4a5568 !important;\n  transition: all 0.2s ease !important;\n}\n\n.dropdown-item:hover {\n  background-color: #f7fafc !important;\n  color: #3a57e8 !important;\n  transform: translateX(4px);\n}\n\n/* Report Preview responsive styles (report?reportId) */\n.reportSectionCard {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  background-color: #e9f0fb;\n  margin-bottom: 16px;\n}\n\n.reportSectionTitle {\n  font-size: 20px;\n  font-weight: 700;\n  color: #2f3299;\n  border-bottom: 2px solid #000;\n  padding-bottom: 6px;\n  display: inline-block;\n  margin-bottom: 16px;\n}\n\n.reportInlineRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 32px;\n  margin-bottom: 10px;\n  align-items: center;\n}\n\n.reportField {\n  color: #2d3748;\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.reportLabel {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.reportValue {\n  font-size: 15px;\n  font-weight: 400;\n  color: #2d3748;\n}\n\n@media (max-width: 768px) {\n  .reportSectionCard {\n    padding: 16px;\n    border-radius: 8px;\n  }\n\n  .reportSectionTitle {\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n\n  .reportInlineRow {\n    gap: 8px 16px;\n  }\n\n  .reportField {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .reportLabel {\n    font-size: 14px;\n  }\n\n  .reportValue {\n    font-size: 13.5px;\n  }\n}\n\n/* Spreadsheet Layout for ReportComponent */\n.spreadsheet-container {\n  width: 100%;\n  overflow-x: auto;\n  background-color: #ffffff;\n  padding: 20px;\n}\n\n.spreadsheet-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: collapse;\n  font-family: \"Inter\", sans-serif;\n  border: 1px solid #d1d5db;\n}\n\n.spreadsheet-table th,\n.spreadsheet-table td {\n  border: 1px solid #d1d5db;\n  padding: 12px 16px;\n  text-align: center;\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.spreadsheet-table th {\n  background-color: #f9fafb;\n  color: #374151;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.spreadsheet-table tr:nth-child(2) th {\n  font-size: 11px;\n  color: #6b7280;\n  background-color: #ffffff;\n  padding: 4px 16px;\n}\n\n.spreadsheet-table tbody tr:hover {\n  background-color: #f3f4f6;\n}\n\n.spreadsheet-td-val {\n  color: #111827;\n  font-weight: 500;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
